import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import {Ticket } from "lucide-react";

const FloatingBetButton = ({ selectedBetsCount, onOpen }) => {
  return (
    <AnimatePresence>
      {selectedBetsCount > 0 && (
        <motion.button
          className="fixed bottom-14 right-3 bg-yellow-500 text-black rounded-full w-16 h-16 flex items-center justify-center shadow-lg z-40"
          whileTap={{ scale: 0.95 }}
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0, opacity: 0 }}
          onClick={onOpen}
        >
          <div className="relative">
            <Ticket className="w-6 h-6" />
            <div className="absolute -top-2 -right-2 bg-red-500 text-white text-xs w-5 h-5 rounded-full flex items-center justify-center">
              {selectedBetsCount}
            </div>
          </div>
        </motion.button>
      )}
    </AnimatePresence>
  );
};

export default FloatingBetButton;
